// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"506":"65d7714c9fa20fb5","677":"d17f0e0d6c543dce","763":"632ed0011b538d27","805":"0613afd65ddbfc7a"}[chunkId] + ".js";
};